import { render } from "./SessionStatusBadge.vue?vue&type=template&id=767c1f9d&scoped=true"
import script from "./SessionStatusBadge.vue?vue&type=script&lang=js"
export * from "./SessionStatusBadge.vue?vue&type=script&lang=js"

import "./SessionStatusBadge.vue?vue&type=style&index=0&id=767c1f9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767c1f9d"]])

export default __exports__